import React, {
  FunctionComponent,
  useState,
  useEffect,
  useContext,
} from "react";
import {
  CloseIconThin,
  HelpDrawer,
  HelpDrawerToggle,
} from "@cmsgov/ds-medicare-gov";
import {
  useTranslate,
  sendTealiumEvent,
  sendTealiumView,
} from "../../../helpers";
import MedigapWaiverStateLinks from "./MedigapWaiverStateLinks";
import {
  linkToMedigapGuaranteedIssueRights,
  linkToMedigapInfo,
} from "../../../helpers/CONSTANTS";
import { AppContext } from "../../../app/store";
import routes from "../../../app/routes";

const SevenThingsDrawer: FunctionComponent = () => {
  const t = useTranslate();
  const { state } = useContext(AppContext);
  const [open, setOpen] = useState(false);

  const close = (): void => {
    sendTealiumEvent(
      "Medigap - Find a Policy - 7 things to know about Medigap",
      "Close"
    );
    setOpen(false);
  };

  const clickHandler = (e: MouseEvent): void => {
    const target = e.target as HTMLElement;
    if (
      !target.closest(".mct-c-help-drawer") &&
      !target.matches(".help-drawer-toggle")
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("click", clickHandler);
      sendTealiumView(
        "7 things to know about Medigap",
        state,
        undefined,
        "help drawer"
      );
    } else {
      document.removeEventListener("click", clickHandler);
    }
  }, [open]);

  return (
    <>
      <HelpDrawerToggle
        helpDrawerOpen={open}
        showDrawer={(): void => {
          setOpen(true);
          sendTealiumEvent(
            "Medigap - Find a Policy",
            "Learn More: 7 things to know about Medigap"
          );
        }}
        className="help-drawer-toggle"
      >
        {t("medigap.help.seven_things_to_know")}
      </HelpDrawerToggle>
      {open && (
        <div className="mct-c-help-drawer ds-u-text-align--left">
          <HelpDrawer
            heading={t("medigap.help.seven_things_to_know")}
            onCloseClick={close}
            closeButtonText={<CloseIconThin />}
          >
            <ol>
              <li>
                <b>{t("medigap.help.seven_things.one")}</b>{" "}
                {t("medigap.help.seven_things.one.details")}
                <p>{t("medigap.help.seven_things.one.more_info")}</p>
                <p>
                  <a
                    href={`#${routes.coverageWizard.landingPage}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(): void => {
                      sendTealiumEvent(
                        "Medigap - Find a Policy - 7 things to know about Medigap",
                        "Compare ways to get coverage"
                      );
                    }}
                  >
                    {t("medigap.help.compare_ways_to_get_coverage")}
                  </a>
                </p>
              </li>
              <li>
                <b>{t("medigap.help.seven_things.two")}</b>{" "}
                {t("medigap.help.seven_things.two.details")}
              </li>
              <li>
                <b>{t("medigap.help.seven_things.three")}</b>
              </li>
              <li>
                <b>{t("medigap.help.seven_things.four")}</b>{" "}
                {t("medigap.help.seven_things.four.details")}
                <p>{t("medigap.help.under_65")}</p>
              </li>
              <li>
                <b>{t("medigap.help.seven_things.five")}</b>{" "}
                {t("medigap.help.seven_things.five.details")}
                <p>
                  {t("medigap.help.seven_things.five.more_info")}{" "}
                  <a
                    href={linkToMedigapGuaranteedIssueRights(state.language)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(): void => {
                      sendTealiumEvent(
                        "Medigap - Find a Policy - 7 things to know about Medigap",
                        "Insurance companies must offer you certain Medigap policies"
                      );
                    }}
                  >
                    {t(
                      "medigap.help.seven_things.five.insurance_companies_must_offer"
                    )}
                  </a>
                </p>
              </li>
              <li>
                <b>{t("medigap.help.seven_things.six")}</b>{" "}
                {t("medigap.help.seven_things.six.details")}
                <MedigapWaiverStateLinks
                  event_action="Medigap - Find a Policy - 7 things to know about Medigap"
                  event_label="Notes: "
                />
              </li>
              <li>
                <b>{t("medigap.help.seven_things.seven")}</b>
              </li>
            </ol>
            <p className="ds-u-margin-top--6">
              <a
                href={linkToMedigapInfo(state.language)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(): void => {
                  sendTealiumEvent(
                    "Medigap - Find a Policy - 7 things to know about Medigap",
                    "Learn more about Medigap"
                  );
                }}
              >
                {t("medigap.learn_more")}
              </a>
            </p>
          </HelpDrawer>
        </div>
      )}
    </>
  );
};

export default SevenThingsDrawer;
